import React, { useEffect, useRef, useState } from 'react'
import Select from "react-select";
import { MdClear, MdOutlineArrowDropDown, MdOutlineArrowDropUp } from "react-icons/md";
import '../../assets/css/register/commonSelect.css'
import {deviceType} from "../../utils/registrationUtils";

const CustomSelect = (props) => {
    const nodeRef = useRef(null);
    const selectRef = useRef(null);
    const { options, name, value } = props;
    const [dropdown, setDropdown] = useState(deviceType == "mobile");
    useEffect(() => {
        if(selectRef?.current) selectRef.current?.blur();
    }, []);

    const handleClickOutside = (event) => {
        if (nodeRef.current && !nodeRef.current.contains(event.target) && dropdown) {
            setTimeout(() => {
            if(deviceType === "web") setDropdown(false)
            else setDropdown(true);
        }, 20)
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside, true);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside, true);
        };
    });

    let removeItem = (e) => {
        e.preventDefault();
        e.stopPropagation();
        try{
            props.onFocus()
        }catch{
            console.log('')
        }
        let filteredList = props?.value?.filter(obj => obj.id !== props?.value?.[0]?.id)
        props.onChange(filteredList)
    }

    let HideInputContainer = (deviceType === 'mobile' && !props.isMulti)
    const areaOfInterestsPlaceholder = props.dropdownDatas?.length > props.maxLimit ?  `Select only upto ${props.maxLimit + 1} ${props.label}` : "Your Interests";
    const handleChange = (option) => {
        if (name == "education_level" ?  (!option || !value || option.id !== value.id) : true) {
          props.onChange(option);
        }
      };
    if(!props.isSearchable){
        return <Select {...props} 
        options={options?.map(option => ({
            ...option,
            isDisabled: name == "education_level" && value && value.id === option.id
          }))}
          onChange={handleChange}
        /> 
    }
    const placeholderData = (name == "education_interest" || name == "degree_pursue") ? 'Search by degree' : name == "area_of_interest" ? 'Search by branch' : 'Search...';
    return (
        <div ref={nodeRef} >
            <div onClick={(e) => {e.preventDefault(); e.stopPropagation() ;if(deviceType == 'web') setDropdown(!dropdown)}}>
                {!HideInputContainer && 
                <div className={((props.errors && !dropdown) && (deviceType == "mobile" ? !props.value : !props.value?.length)) ? "input_container invalid_field white_bg" : (props.value &&
                                    (Array.isArray(props.value)
                                        ? (props.showLimit || props.value.length > 0)
                            : Object.keys(props.value).length > 0)) ? "input_container white_bg" : "input_container"}
                >
                        <div className='d-flex justify-space-between'>
                            {!props.isMulti && <>{(props.value?.[props.label] || props.value?.value) ? <div>{props.value?.[props.label] || props.value?.value}</div> : <div className='floating_label'>{props.placeholder}</div>}</>}
                            {props.isMulti && 
                                <>
                                    {props?.value?.[0] ?
                                        <div className='selected_option_cover'>
                                            <div className='selected_option'>
                                              <span>{props?.value?.[0]?.label || props.value?.[0]?.value}</span>  
                                            <span onClickCapture={(e) => { removeItem(e)}} className='remove'><MdClear /></span>
                                            </div>
                                            {props?.value?.length > 1 && <div className='btn multi_select_more' 
                                            >{`+${props?.value?.length - 1} More`}</div>}
                                        </div>
                                        : 
                                        <div>{props.placeholder}</div>
                                    }
                            </>
                            }
                            {((deviceType==="mobile")&&(!props.value?.length > 0)) && <span className="floating_label" id="careers_registration__limit_info">{props.name == "area_of_interest" ? areaOfInterestsPlaceholder : `Select only upto ${props.maxLimit + 1} ${props.label}`}</span>}
                            
                            <div className='custom_Select_indicator'>{dropdown ? <MdOutlineArrowDropUp /> : <MdOutlineArrowDropDown />}</div>
                        </div>
                </div>}
            </div>
            {dropdown &&
                <div className='dropdown_container '>
                    <Select
                        {...props}
                        placeholder={placeholderData}
                        ref={selectRef}
                        menuIsOpen
                        controlShouldRenderValue={false}
                        isClearable={false}
                        autoFocus
                        isSearchable={props?.isSearchableForMultiSelect}
                        onChange={(option) => {
                            props.onChange(option);
                            if (!props.isMulti) {
                                setDropdown(false);
                            }
                        }}
                        styles={{
                            ...props.styles,
                            menu: (base, state) => ({
                                ...base,
                                position: 'unset',
                                boxShadow:'none',
                                marginTop:"4px",
                            }),
                            groupHeading:(base,state)=>({
                                ...base,
                                textTransform:"capitalize",
                                fontSize:"12px",
                                fontWeight:"500",
                              }),
                            option:(base,state)=>({
                                ...base,
                                background: state.isSelected || (deviceType === 'web' && state.isFocused )? 'rgba(0, 0, 0, 0.04) !important' : '#fff',
                                color:state.isDisabled?'#ccc':'#111',
                                cursor: 'pointer',
                                ":hover": {
                                    background: "rgba(0, 0, 0, 0.04) !important",
                                }
                            }),
                            control: (base, state) => ({
                                ...base,
                                borderColor: '#ccc',
                                background: '#F8F8F8',
                                borderRadius: "3px",
                                height: "39px",
                                boxShadow: "none",
                                border: (props.errors?.[name] && props.touched?.[name] && !state.menuIsOpen) && '1px solid #b3261e',
                                ":hover": {
                                    borderColor: (props.errors?.[name] && props.touched?.[name] && !state.menuIsOpen) ? '#b3261e' : '#ccc',
                                },
                            }),
                            menuList: (base) => ({
                                ...base,
                                marginLeft:'-5px',
                                paddingBottom:  deviceType === 'mobile' ? '80px':'0px',
                                "::-webkit-scrollbar": {
                                    width: "4px",
                                    height: "0px",
                                    borderRadius:'4px',
                                },
                                "::-webkit-scrollbar-track": {
                                    background: "#F1F1F1"
                                },
                                "::-webkit-scrollbar-thumb": {
                                    background: "#999"
                                },
                                "::-webkit-scrollbar-thumb:hover": {
                                    background: "#555"
                                },
                            }),
                            dropdownIndicator: (provided, state) => ({
                                ...provided,
                                display: 'none',
                            }),
                        }}
                    />
                </div>
            }
        </div>
    )
}

export default CustomSelect

